import { REASONS } from "@/data/site";
import { useLiveStats } from "@/lib/liveStats";

export default function WhyUs() {
  const stats = useLiveStats();
  const sub = (t) => (t || "").replaceAll("{{count}}", String(stats.total));
  return (
    <section className="py-28 md:py-40 bg-[#F5F0EA] relative grain overflow-hidden">
      <div className="max-w-[1240px] mx-auto px-6 md:px-10">
        <div className="text-center max-w-3xl mx-auto mb-20">
          <p className="overline mb-7">Why couples choose us</p>
          <h2 className="font-serif text-[2.6rem] sm:text-[3.4rem] md:text-[4.6rem] leading-[1.04] tracking-tight text-stone-900">
            The biggest regret of couples
            <br />
            <em className="italic font-normal text-stone-600">who don&apos;t book a videographer?</em>
          </h2>
          <p className="mt-9 font-serif italic text-3xl md:text-4xl text-stone-800">
            Not booking a videographer.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-y-16 gap-x-20 max-w-4xl mx-auto">
          {REASONS.map((r) => (
            <div key={r.n} data-testid={`why-${r.n}`} className="text-center md:text-left">
              <p className="font-serif italic text-stone-500 text-xl mb-3">{r.n}</p>
              <h3 className="font-serif text-[1.65rem] md:text-[1.9rem] text-stone-900 leading-tight">
                {sub(r.title)}
              </h3>
              <p className="mt-4 font-serif text-stone-700 text-[1.1rem] leading-[1.65]">
                {sub(r.body)}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
